import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useReducer } from 'react';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { loadDeviceZ3kConfig, } from 'z3k-settings/components/view-config/redux/actions';
import { Stack, Typography } from '@mui/material';
import { get_history_configs_values } from '../view-config/utils';
import { can_use_config_history } from 'console/account/account_tsx';
import { ItemStyle } from 'z3k-settings/components/history-z3k-config/style';
import { ButtonForHistoryConfig, HistoryConfigForTime, } from 'z3k-settings/components/history-z3k-config/utils';
import { AccordionWithValidation } from 'z3k-settings/components/material-utils/accordion-with-validation';
import { getRealScreenWidth } from 'z3k-settings/components/utils/getRealScreenWidth';
import { MainCompare } from 'z3k-settings/components/history-z3k-config/compare';
const z3k_config_history_loading_selector = (state) => state.z3k_device_config_history.is_config_set_load;
export const z3k_config_history_selector = (state) => state.z3k_device_config_history.config_history;
const z3k_config_history_device_id_selector = (state) => state.z3k_device_config_history.current_device_id;
export function ConfigHistory(props) {
    const { device_id, show_anyway } = props;
    const history_configs = useAppSelector(z3k_config_history_selector);
    const loaded_config_history_device_id = useAppSelector(z3k_config_history_device_id_selector);
    const [x, forceUpdate] = useReducer((x) => x + 1, 0);
    const is_large_screen = useMemo(() => getRealScreenWidth() >= 540, [x]);
    const load_device_config_history = useAction(loadDeviceZ3kConfig);
    const config_history_values = get_history_configs_values(history_configs);
    const can_user_config_history = useAppSelector(can_use_config_history);
    const is_user_pro = can_user_config_history || show_anyway;
    const loading = useAppSelector(z3k_config_history_loading_selector);
    const saveCount = history_configs.filter((config) => config.save).length;
    useEffect(() => {
        (async () => {
            if (is_user_pro) {
                load_device_config_history(device_id);
            }
        })();
    }, [device_id]);
    useEffect(() => {
        window.addEventListener('orientationchange', forceUpdate);
        return () => window.removeEventListener('orientationchange', forceUpdate);
    }, []);
    return (_jsx(_Fragment, { children: loaded_config_history_device_id === device_id && (_jsx(Stack, { spacing: 2, sx: { display: 'flex', flexDirection: 'column', margin: '10px' }, children: config_history_values.map((values) => {
                return (_jsxs(ItemStyle, { sx: {
                        border: history_configs[values.id].save
                            ? '2px solid green'
                            : 'none',
                    }, children: [_jsx(ButtonForHistoryConfig, { loading: loading, values: values, device_id: device_id, config_id: history_configs[values.id].config_id, save: history_configs[values.id].save, save_count: saveCount }), values.id !== history_configs.length - 1 && (_jsx(MainCompare, { is_large_screen: is_large_screen, newConfig: history_configs[values.id], history_configs: history_configs[values.id + 1].config_parsed })), _jsx(AccordionWithValidation, { slotProps: { transition: { unmountOnExit: true } }, validation_result: null, validation_warnings_result: null, header: _jsx(Typography, { children: "\u041A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044F" }), children: _jsx(HistoryConfigForTime, { config: history_configs[values.id] }) })] }, values.id));
            }) })) }));
}
